import {Component, Input} from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-why-atom-lg-header',
  template: `
    <ion-toolbar class="padding-top-40 min-ht">
      <ion-buttons slot="start" (click)="back()">
        <ion-icon name="chevron-back-outline" class="icon-30 add__color primary-shade"></ion-icon>
      </ion-buttons>
    </ion-toolbar>
    <ion-toolbar class="min-ht-35 pd-top-16">
      <ion-label no-margin
                 class="main-header pd-left-16">{{title}}</ion-label>
    </ion-toolbar>
    <ion-toolbar class="min-ht-30">
      <span class="sub-header pd-left-16 dark-tint display-inline">{{subTitle}}</span>
    </ion-toolbar>
  `,
  styleUrls: ['./atom-large-header.component.scss']
})

export class AtomLargeHeaderComponent {
  @Input() title = '';
  @Input() subTitle = '';
  constructor(private location: Location) {
  }

  back() {
    this.location.back();
  }
}
